import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useAuthContext } from '@/ui/contexts/AuthContext'

import { unreadCountInstance } from '../..'
import { UnreadCountsEnum } from '../../domain/models/UnreadCountsEnum'
import { setTicketChatUserNotificationCount } from '../../services/cache/UnreadCountCacheManager'

export function useTicketChatUserNotificationCounterEvents() {
  const queryClient = useQueryClient()
  const { personaSession } = useAuthContext()

  useEffect(() => {
    if (!personaSession?.personaId) return

    const unsubscribeTicketChatNotification =
      unreadCountInstance.getUnreadCount({
        profileId: personaSession.personaId,
        countPath: UnreadCountsEnum.enum.ticketChats,
        onValue: (snapshot) => {
          const count = snapshot.val() as number
          setTicketChatUserNotificationCount({ count }, queryClient)
        }
      })

    return () => {
      unsubscribeTicketChatNotification()
    }
  }, [personaSession?.personaId])
}
